import moment from "moment";

const DateField = ({fecha, fechaAdd}:any) => {
    return (
        <div>
            {moment(fecha ? new Date(Number(fecha)) : fechaAdd).format('DD/MM/YYYY')}
        </div>
    )
}
export default DateField;